export default class MemberComplianceService {
  constructor($http) {
    'ngInject';

    this.$http = $http;
  }

  process() {
    return this.$http.post('/api/compliance/process');
  }

  getNonCompliantCompanies() {
    return this.$http.get('/api/compliance/get_fail_list');
  }

  getCompliantCompanies() {
    return this.$http.get('/api/compliance/get_pass_list');
  }
}



// WEBPACK FOOTER //
// ./components/app/admin/member-compliance/member-compliance.service.js